import { Timeline } from "./Timeline";
import { Entry } from "./Entry";

Timeline.Entry = Entry;
export { Timeline, Entry };
